import { useMemo } from 'react'
import { getLevelName, getTeamFullName, toLevelTeamMap, type SelectItem } from '@front/model'
import { type CompanyData, type TeamData, type TeamId } from '@terros/common'

type GroupedTeamOption = {
  group: string
  items: SelectItem<TeamId>[]
}

export const useGroupedTeamOptions = (availableTeams: TeamData[], company?: CompanyData): GroupedTeamOption[] => {
  const groupedTeams = useMemo(() => toLevelTeamMap(availableTeams), [availableTeams])
  return useMemo(() => {
    return Array.from(groupedTeams.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([level, teams]) => ({
        group: getLevelName(company, level),
        items: teams.map((team) => ({
          value: team.teamId,
          label: getTeamFullName(company, team),
        })),
      }))
  }, [groupedTeams, company])
}
